/* tslint:disable */

declare var Object: any;
export interface TenantLeaseEventsModelInterface {
  "lease_id": number;
  "user_id": number;
  "memo": string;
  "tenant_lease_id": number;
  "id"?: number;
}

export class TenantLeaseEventsModel implements TenantLeaseEventsModelInterface {
  "lease_id": number;
  "user_id": number;
  "memo": string;
  "tenant_lease_id": number;
  "id": number;
  constructor(data?: TenantLeaseEventsModelInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TenantLeaseEventsModel`.
   */
  public static getModelName() {
    return "TenantLeaseEventsModel";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TenantLeaseEventsModel for dynamic purposes.
  **/
  public static factory(data: TenantLeaseEventsModelInterface): TenantLeaseEventsModel{
    return new TenantLeaseEventsModel(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TenantLeaseEventsModel',
      plural: 'TenantLeaseEventsModels',
      path: 'TenantLeaseEventsModels',
      idName: 'id',
      properties: {
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "user_id": {
          name: 'user_id',
          type: 'number'
        },
        "memo": {
          name: 'memo',
          type: 'string'
        },
        "tenant_lease_id": {
          name: 'tenant_lease_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
